<template>
	<div class="add">
		<a-card class="add-container" :title="id ? '编辑商户' : '新增商户'">
			<a-form ref="merchantRef" :model="ruleForm" :rules="rules" :label-col="{ span: 8 }" :wrapper-col="{ span: 14 }">
				<div class="section-header">基础信息</div>
				<a-row :gutter="24">
					<a-col :span="12">
						<a-form-item ref="name" label="商户名称" name="name">
							<a-input v-model:value="ruleForm.name" placeholder="请输入商户名称" />
						</a-form-item>
					</a-col>
					<a-col :span="12" v-if="!id">
						<a-form-item ref="userName" label="主账户" name="userName">
							<a-input v-model:value="ruleForm.userName" placeholder="请输入主账户名称" />
						</a-form-item>
					</a-col>
					<a-col :span="12">
						<a-form-item ref="trade" label="行业" name="trade">
							<SelectTradeList v-model:value="ruleForm.trade" />
						</a-form-item>
					</a-col>
					<a-col :span="12">
						<a-form-item ref="mobile" label="手机号" name="mobile">
							<a-input v-model:value="ruleForm.mobile" placeholder="请输入手机号" />
						</a-form-item>
					</a-col>
					<a-col :span="12">
						<a-form-item ref="merchantType" label="商户类型" name="merchantType">
							<a-select v-model:value="ruleForm.merchantType" placeholder="请选择商户类型">
								<a-select-option value="COMPANY"> 单个公司 </a-select-option>
								<a-select-option value="GROUP"> 集团公司 </a-select-option>
							</a-select>
						</a-form-item>
					</a-col>
					<a-col :span="12">
						<a-form-item ref="appTypeList" label="应用提供商-应用类型" name="appTypeList">
							<a-select mode="multiple" v-model:value="ruleForm.appTypeList" placeholder="请选择应用类型">
								<a-select-option v-for="(item, index) in appList" :key="index" :value="item.appType">
									{{ item.desc }}
								</a-select-option>
							</a-select>
						</a-form-item>
					</a-col>
					<a-col :span="12">
						<a-form-item ref="serviceTypeList" label="服务提供商-服务类型" name="serviceTypeList">
							<a-select mode="multiple" v-model:value="ruleForm.serviceTypeList" placeholder="请选择服务类型">
								<a-select-option v-for="(item, index) in serviceList" :key="index" :value="item.serviceType">
									{{ item.desc }}
								</a-select-option>
							</a-select>
						</a-form-item>
					</a-col>
				</a-row>

				<template v-if="rootDepartment && rootDepartment.departmentExt">
					<a-divider />
					<div class="section-header">公司信息</div>
					<a-row :gutter="24">
						<a-col :span="12">
							<a-form-item label="公司全称">
								<a-input v-model:value="rootDepartment.departmentExt.fullName" placeholder="请输入公司全称" />
							</a-form-item>
						</a-col>
						<a-col :span="12">
							<a-form-item label="公司英文全称">
								<a-input v-model:value="rootDepartment.departmentExt.fullNameEn" placeholder="请输入公司英文全称" />
							</a-form-item>
						</a-col>
						<a-col :span="12">
							<a-form-item label="法定代表人">
								<a-input v-model:value="rootDepartment.departmentExt.corporation" placeholder="请输入法定代表人" />
							</a-form-item>
						</a-col>
						<a-col :span="12">
							<a-form-item label="记账本位币">
								<SelectCurrency v-model:code="rootDepartment.departmentExt.currency" />
							</a-form-item>
						</a-col>
						<a-col :span="12">
							<a-form-item label="统一社会信用识别号">
								<a-input v-model:value="rootDepartment.departmentExt.unifiedBusinessIdentifier" placeholder="请输入统一社会信用识别号" />
							</a-form-item>
						</a-col>
						<a-col :span="12">
							<a-form-item label="纳税人识别号">
								<a-input v-model:value="rootDepartment.departmentExt.taxpayerIdentificationNo" placeholder="请输入纳税人识别号" />
							</a-form-item>
						</a-col>
						<a-col :span="12">
							<a-form-item label="SWIFT编码">
								<a-input v-model:value="rootDepartment.departmentExt.swiftCode" placeholder="请输入SWIFT编码" />
							</a-form-item>
						</a-col>
						<a-col :span="12">
							<a-form-item label="银行开户行名称">
								<a-input v-model:value="rootDepartment.departmentExt.bankName" placeholder="请输入银行开户行名称" />
							</a-form-item>
						</a-col>
						<a-col :span="12">
							<a-form-item label="银行账号">
								<a-input v-model:value="rootDepartment.departmentExt.bankAccount" placeholder="请输入银行账号" />
							</a-form-item>
						</a-col>
						<a-col :span="12">
							<a-form-item label="银行地址">
								<a-input v-model:value="rootDepartment.departmentExt.bankAddress" placeholder="请输入银行地址" />
							</a-form-item>
						</a-col>
						<a-col :span="12">
							<a-form-item label="银行持卡人">
								<a-input v-model:value="rootDepartment.departmentExt.bankCardholder" placeholder="请输入银行持卡人" />
							</a-form-item>
						</a-col>
						<a-col :span="12">
							<a-form-item label="持卡人联系方式">
								<a-input v-model:value="rootDepartment.departmentExt.cardholderMobile" placeholder="请输入持卡人联系方式" />
							</a-form-item>
						</a-col>
						<a-col :span="12">
							<a-form-item label="国家/地区代码">
								<a-input v-model:value="rootDepartment.departmentExt.countryCode" placeholder="请输入国家/地区代码" />
							</a-form-item>
						</a-col>
						<a-col :span="12">
							<a-form-item label="公司地址">
								<a-input v-model:value="rootDepartment.departmentExt.address" placeholder="请输入公司地址" />
							</a-form-item>
						</a-col>
						<a-col :span="12">
							<a-form-item label="联系电话">
								<a-input v-model:value="rootDepartment.departmentExt.mobile" placeholder="请输入联系电话" />
							</a-form-item>
						</a-col>
						<a-col :span="12">
							<a-form-item label="成立日期">
								<DateRangePicker
									:needhms="false"
									:singleDatePicker="true"
									:startTime="rootDepartment.departmentExt.establishTime"
									@get_date="getDate"
								/>
							</a-form-item>
						</a-col>
					</a-row>
				</template>

				<div class="footer-actions">
					<a-button type="primary" @click="submitAdd" :loading="loading" size="large">
						{{ id ? "保存修改" : "确认创建" }}
					</a-button>
					<a-button style="margin-left: 12px" @click="backUp" size="large">返回列表</a-button>
				</div>
			</a-form>
		</a-card>
	</div>
</template>

<script>
import { reactive, ref, toRefs, onActivated, onBeforeUnmount, getCurrentInstance } from "vue"
import axios from "@/common/axios"
import api from "@/common/api/api"
import { message } from "ant-design-vue"
import { useRoute, useRouter } from "vue-router"
import { localGet } from "@/common/utils"
import SelectTradeList from "@/components/SelectTradeList"
import DateRangePicker from "@/components/DateRangePicker"
import SelectCurrency from "@/components/SelectCurrency"
export default {
	name: "AddMerchant",
	components: { SelectTradeList, DateRangePicker, SelectCurrency },
	setup() {
		const { proxy } = getCurrentInstance()
		console.log("proxy", proxy)
		const editor = ref(null)
		const merchantRef = ref(null)
		const route = useRoute()
		const router = useRouter()

		const isNameHave = async (type, value) => {
			console.log(state.id)
			let data = {}
			let idParams = state.id ? state.id.id : ""
			if (type == "name") {
				data = { id: idParams || "", name: value, nameType: "MERCHANT" }
			} else {
				data = { id: idParams || "", name: value, nameType: "USER" }
			}
			let exist = false
			await axios.post(api.isNameHave, data).then((res) => {
				exist = res.exist
			})
			return exist
		}
		let validateName = async () => {
			if (state.ruleForm.name === "") {
				return Promise.reject("请输入商户名称")
			} else if (state.ruleForm.name !== "") {
				if (await isNameHave("name", state.ruleForm.name)) {
					return Promise.reject("当前名称重复，请重新输入")
				}
				return Promise.resolve()
			}
		}
		let validateUserName = async () => {
			if (state.ruleForm.userName === "") {
				return Promise.reject("请输入主账户名称")
			} else if (state.ruleForm.userName !== "") {
				if (await isNameHave("username", state.ruleForm.userName)) {
					return Promise.reject("当前名称重复，请重新输入")
				}
				return Promise.resolve()
			}
		}
		const state = reactive({
			token: localGet("token") || "",
			id: "",
			defaultCate: "",
			ruleForm: {
				id: "",
				mobile: "",
				name: "",
				userName: "",
				appTypeList: undefined,
				serviceTypeList: undefined,
				trade: undefined,
			},
			rootDepartment: {
				departmentExt: {
					fullName: "",
					fullNameEn: "",
					corporation: "",
					currency: undefined,
					unifiedBusinessIdentifier: "",
					taxpayerIdentificationNo: "",
					swiftCode: "",
					bankName: "",
					bankAccount: "",
					bankAddress: "",
					bankCardholder: "",
					cardholderMobile: "",
					countryCode: "CN",
					address: "",
					mobile: "",
					establishTime: null,
				},
			},
			rules: {
				name: [{ required: "true", validator: validateName, trigger: "blur" }],
				mobile: [{ required: "true", message: "请填写手机号", trigger: "blur" }],
				userName: [{ required: "true", validator: validateUserName, trigger: "blur" }],
			},
			appList: [],
			serviceList: [],
			loading: false,
		})

		onActivated(() => {
			merchantRef.value.resetFields()
			state.id = route.query.id
			getAppList()
			getServiceList()
			state.ruleForm = {}
			if (state.id) {
				state.id = JSON.parse(state.id)
				state.ruleForm.id = state.id.id
				state.ruleForm.mobile = state.id.mobile
				state.ruleForm.name = state.id.name
				state.ruleForm.userName = state.id.createdUser
				state.ruleForm.appTypeList = state.id.appTypeList || undefined
				state.ruleForm.serviceTypeList = state.id.serviceTypeList || undefined
				state.ruleForm.trade = state.id.trade || undefined
			}
			getMerchantDetailWithRootDepartment()
			// console.log(state.ruleForm)
		})
		onBeforeUnmount(() => {})
		const submitAdd = () => {
			merchantRef.value
				.validate()
				.then(async () => {
					state.loading = true
					const params = { merchant: { ...state.ruleForm } }
					try {
						await axios.post(api.saveMerchant, params)
						// If editing, also save department info
						if (state.id && state.rootDepartment && state.rootDepartment.id) {
							await axios.post(api.departmentSave, {
								department: state.rootDepartment,
							})
						}
						message.success(state.id ? "修改成功" : "添加成功")
						state.loading = false
						router.push({ name: "merchantManage" })
					} catch (error) {
						state.loading = false
						console.log(error)
					}
				})
				.catch((error) => {
					state.loading = false
					console.log("error", error)
				})
		}
		const backUp = () => {
			console.log("router", router)
			router.back()
		}
		const getAppList = async () => {
			let res = await axios.post(api.getAppTypeList, {})
			state.appList = res
		}
		const getServiceList = async () => {
			let res = await axios.post(api.getServiceTypeList, {})
			state.serviceList = res
		}
		const getMerchantDetailWithRootDepartment = async () => {
			if (!state.ruleForm.id) return
			let res = await axios.post(api.getMerchantDetailWithRootDepartment, {
				merchantId: state.ruleForm.id,
			})
			console.log("res", res)
			if (res) {
				state.rootDepartment = res.rootDepartment || { departmentExt: {} }
				if (!state.rootDepartment.departmentExt) {
					state.rootDepartment.departmentExt = { countryCode: "CN" }
				}
			}
		}
		const getDate = (value) => {
			state.rootDepartment.departmentExt.establishTime = value.startTime
		}
		return {
			...toRefs(state),
			merchantRef,
			submitAdd,
			editor,
			backUp,
			getDate,
			labelCol: { span: 8 },
			wrapperCol: { span: 16 },
		}
	},
}
</script>

<style scoped lang="scss">
.add {
	padding: 24px;
	background-color: #f0f2f5;
	min-height: 100vh;
}
.add-container {
	max-width: 1000px;
	margin: 0 auto;
	border-radius: 8px;
	box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
}
.section-header {
	font-size: 18px;
	font-weight: 600;
	color: #1a1a1a;
	margin-bottom: 24px;
	padding-left: 12px;
	border-left: 4px solid #1890ff;
	line-height: 1;
}
.footer-actions {
	margin-top: 40px;
	padding-top: 24px;
	border-top: 1px solid #f0f0f0;
	text-align: center;
}
:deep(.ant-form-item-label) {
	font-weight: 500;
}
:deep(.ant-divider-horizontal) {
	margin: 32px 0;
}
</style>
